import React from "react";
import { Transition } from 'react-transition-group';

import useIsInViewport from "ui/hooks/inViewport";

import AbstractPlus from "./AbstractPlus";


const duration = 1500;

const defaultStyle = {
  transition: `all ${duration}ms ease-in-out`,
  top : "49%",
  left : "49%",
  transform: 'rotate(0deg)',
  opacity : 0,
  width : 10,
  height : 10,
}

const sizes = [ 8,10,12,14,16,18,20,22 ];

const AbstractPlusScatter = ({count, wrapperSize, className}) => {
    const [inView, childElemToWatch] = useIsInViewport();

    let scatterArray = [];
    const yItems = 4, xItems = Math.floor( count/ yItems );
    const scatterMap = [];
    const xFactor = Math.floor(100 / xItems);
    const yFactor = Math.floor(100 / yItems);
    for( let x = 1; x <= xItems; x++ ){
        for( let y = 1; y <= yItems; y++ ){
            scatterMap.push( { x : x * xFactor, y : y * yFactor } );
        }
    }
    for( let i = count; i >= 0; i-- ){
        const size = sizes[Math.floor(Math.random()*sizes.length)];
        let opacity = Math.random() * 0.3;
        if( opacity > 0.5 ){
            opacity = opacity - 0.25;
        } else if( opacity < 0.05 ){
            opacity = opacity + 0.05;
        }
        const scatterCoords = scatterMap[i];
        if( scatterCoords ){
            const xPosition = ( Math.floor(Math.random()*( scatterCoords.x - ( scatterCoords.x - xFactor )) + scatterCoords.x - xFactor ))+"%";
            const yPosition = ( Math.floor(Math.random()*( scatterCoords.y - ( scatterCoords.y - yFactor )) + scatterCoords.y - 2*xFactor ))+"%";
            scatterArray.push( { entered : { width : size , height : size , opacity : opacity, left : xPosition, top : yPosition, transform : "rotate(360deg)" }, entering : { transform : 'rotate(180deg)' }, exiting : { transform : 'rotate(180deg)' }, exited : { ...defaultStyle } } );
        }
    }
    return (
        <div ref={childElemToWatch} className={"position-absolute " + ( className ? className : "" )} style={{"width": wrapperSize.width || "100%", "height": wrapperSize.height || "100%", "top" :0, "left" : 0, "zIndex" : 1}}>
            {scatterArray.map( (item,index) => (
                <Transition key={index} in={inView} timeout={800} >
                    { state => (
                        <div className="position-absolute" style={{ ...defaultStyle, ...scatterArray[index][state] }}><AbstractPlus /></div>
                    )}
                </Transition>
            ))}
        </div>
    )
}

export default AbstractPlusScatter;